export const colors = {
    day: {
        text: '#000',
        disabledText: '#aaa',
        selected: '#fa0',
    },
};
